import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./Home.css";
import Product from "./Product";
function Home() {
  return (
    <div className="home">
      <div className="home-container">
        <img
          className="home-image"
          src="https://m.media-amazon.com/images/I/51PL6-WGyML._SX3000_.jpg"
          alt="banner"
        />

        <div className="home-row">
          <Product
            title="abra Elite Active 65t Alexa Enabled True Wireless "
            image="https://m.media-amazon.com/images/I/41gFkfkyrcL._AC_SY200_.jpg"
            rating={5}
            price={50}
          />
          <Product
            title="Boult Audio AirBass TrueBuds True Wireless Earbuds with 30 "
            image="https://images-eu.ssl-images-amazon.com/images/I/41oQwPLC4XL._SX300_SY300_QL70_FMwebp_.jpg"
            rating={4}
            price={150}
          />
          <Product
            title="boAt Airdopes 201 Bluetooth Truly Wireless Earbuds with "
            image="https://m.media-amazon.com/images/I/61uy5UraVUL._SL1500_.jpg"
            rating={4}
            price={250}
          />
          <Product
            title="
            boAt Airdopes 121v2 Truly Wireless Bluetooth in Ear Earbuds with Mic (Active Black) "
            image="https://m.media-amazon.com/images/I/71ByNT34bfL._SL1500_.jpg"
            rating={3}
            price={450}
          />
        </div>
        <div className="home-row">
          <Product
            title="OnePlus Nord 2 5G (Gray Sierra, 8GB RAM, 128GB Storage) "
            image="https://m.media-amazon.com/images/I/71KVeQql77S._SL1500_.jpg"
            rating={5}
            price={850}
          />

          <Product
            title="OnePlus 9R 5G (Lake Blue, 8GB RAM, 128GB Storage)"
            image="https://m.media-amazon.com/images/I/61IwksZ-DGL._SL1500_.jpg"
            rating={5}
            price={1250}
          />

          <Product
            title="Mi 11X 5G Lunar White 6GB RAM 128GB ROM | SD 870 | DisplayMate A+ rated E4 AMOLED "
            image="https://m.media-amazon.com/images/I/71dzpD1c85S._SL1500_.jpg"
            rating={5}
            price={850}
          />

          <Product
            title="Samsung Galaxy A52s 5G (Black, 8GB RAM, 128GB Storage)  "
            image="https://m.media-amazon.com/images/I/91zjIiEiPQL._SL1500_.jpg"
            rating={5}
            price={850}
          />
        </div>

        <div className="home-row">
          <Product
            title="Noise ColorFit Pro 2 Full Touch Control Smart Watch  "
            image="https://m.media-amazon.com/images/I/61xzuXWWozS._SL1200_.jpg"
            rating={5}
            price={250}
          />

          <Product
            title="Apple Watch Series 3  "
            image="https://m.media-amazon.com/images/I/71EoGntO5bL._SL1500_.jpg"
            rating={4}
            price={850}
          />

          <Product
            title="Mi Watch Revolve (Midnight Black) "
            image="https://m.media-amazon.com/images/I/71NPqRmWj4L._SL1500_.jpg"
            rating={5}
            price={350}
          />

          <Product
            title="Samsung Galaxy Watch 3  "
            image="https://m.media-amazon.com/images/I/717WeOKf-TL._SL1500_.jpg"
            rating={4}
            price={450}
          />
        </div>

        <div className="home-row">
          <Carousel>
            <Product
              title="Samsung Galaxy Watch 3  "
              image="https://m.media-amazon.com/images/I/717WeOKf-TL._SL1500_.jpg"
              rating={4}
              price={450}
            />
            <Product
              title="Samsung Galaxy Watch 3  "
              image="https://m.media-amazon.com/images/I/717WeOKf-TL._SL1500_.jpg"
              rating={4}
              price={450}
            />
            <Product
              title="Samsung Galaxy Watch 3  "
              image="https://m.media-amazon.com/images/I/717WeOKf-TL._SL1500_.jpg"
              rating={4}
              price={450}
            />
          </Carousel>
        </div>
      </div>
    </div>
  );
}

export default Home;
